import { VIEW_ROLE } from "constants/forge";
import { useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import {
  clearHighlightObject,
  getViewerRole,
  highlightObject,
} from "utils/forge";

export type TargetObject = {
  dbIds: number[];
  color: string;
};

const useBehaviorTargetObjects = () => {
  const { isLoadedViewerModelData } = useSelector(
    (state: RootState) => state.forgeViewer
  );
  const viewerRole = useRef<VIEW_ROLE>();

  const lastDbIdsHighlightRef = useRef<number[]>([]);

  const clearHighlighTargetObjectByDbIds = useCallback(
    (isResetThemingColor = false) => {
      if (!viewerRole.current) {
        return;
      }
      const currentViewerRole = getViewerRole();
      const lastViewerRole = viewerRole.current;
      if (currentViewerRole !== lastViewerRole) {
        return;
      }
      clearHighlightObject(
        lastViewerRole,
        lastDbIdsHighlightRef.current,
        undefined,
        undefined,
        undefined,
        isResetThemingColor
      );
    },
    []
  );

  const highlightTargetObjectsWithExcludeDbIds = useCallback(
    (params: { targetObject: TargetObject; excludeDbIds: number[] }) => {
      if (!isLoadedViewerModelData) {
        return;
      }
      const { targetObject: _targetObject, excludeDbIds } = params;
      if (!_targetObject) {
        return;
      }
      viewerRole.current = getViewerRole();
      const dbIds = _targetObject.dbIds || [];
      const filterDbIds = dbIds.filter((dbId) => !excludeDbIds.includes(dbId));
      const targetObject = { ..._targetObject, dbIds: filterDbIds };
      lastDbIdsHighlightRef.current = targetObject.dbIds;
      highlightObject({ dbIds: targetObject.dbIds, color: targetObject.color });
    },
    [isLoadedViewerModelData]
  );

  return {
    highlightTargetObjectsWithExcludeDbIds,
    clearHighlighTargetObjectByDbIds,
  };
};

export default useBehaviorTargetObjects;
